module.exports = __webpack_public_path__ + "static/media/profile-cover.e2582654.jpg";